import React from 'react';
import PropTypes from 'prop-types';
import BuildingsExportCsvModal from './ExportCsvModal';

function MassActions({ checkedIds, queryParams }) {
  const buildingIds = checkedIds && checkedIds.length > 0 ? checkedIds.join() : null;

  return (
    <div className="qmb-actions">
      <div className="actions__group">
        <BuildingsExportCsvModal disabled={false} buildingIds={buildingIds} queryParams={queryParams} />
      </div>
    </div>
  );
}

MassActions.propTypes = {
  checkedIds: PropTypes.arrayOf(PropTypes.number),
  queryParams: PropTypes.object.isRequired
};

MassActions.defaultProps = {
  checkedIds: []
};

export default MassActions;
